module.exports = __webpack_public_path__ + "media/images/welcome_page_my_apps-c7002c0620ce5c9c736ece95c36c1282.png";